import isString from 'lodash/isString'

export const splitRegistration = (registration: any) => {
  if (!isString(registration)) {
    return { countryCode: '', licensePlate: '' }
  }

  let [countryCode = '', licensePlate = ''] = registration.split('|')

  countryCode = countryCode.toUpperCase()
  licensePlate = licensePlate.toUpperCase()

  return {
    countryCode,
    licensePlate
  }
}
